import Switch from "@mui/material/Switch";
import { useDispatch, useSelector } from "react-redux";
import { updateUserProfile } from "@/state/profileSlice";
import { ThemeTypes } from "@/utils/constants";
import { useEffect, useState } from "react";

export const ThemeSwitcher = () => {
    const profile = useSelector((state) => state.profile);
    const dispatch = useDispatch();
    const theme = profile.data?.webTheme?.id || ThemeTypes.dark.id;

    const [localTheme, setLocalTheme] = useState(theme);

    const setTheme = (theme) => {
        dispatch(
            updateUserProfile({
                ...profile.data,
                webTheme: ThemeTypes[theme] || ThemeTypes.dark,
            }),
        );
    };

    useEffect(() => {
        if (!profile.loading && profile.updateError) {
            setTimeout(() => {
                setLocalTheme(theme);
            }, 500);
        }
    }, [profile.updateError, profile.loading]);

    useEffect(() => {
        setLocalTheme(theme);
    }, [theme]);

    return (
        <div className="flex items-center flex-col md:flex-row">
            <Switch
                className="cm-toggle border border-cm-outline-medium"
                checked={localTheme === ThemeTypes.dark.id}
                onChange={() => {
                    setLocalTheme(localTheme === ThemeTypes.dark.id ? ThemeTypes.light.id : ThemeTypes.dark.id);
                    setTheme(theme === ThemeTypes.dark.id ? ThemeTypes.light.id : ThemeTypes.dark.id);
                }}
            />
        </div>
    );
};
